<template>
    <Button v-bind="$attrs" variant="filled" v-on="$listeners">
        <template v-for="(_, slot) in $slots" v-slot:[slot]>
            <slot :name="slot" />
        </template>
    </Button>
</template>

<script>
import Button from './Button';

export default {
    name: 'DsFilledButton',
    components: { Button },
    inheritAttrs: false,
};
</script>
